/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

import { Wholesaler } from "./wholesaler";
import { Period } from "./period";
import { Retailer } from "./retailer";

export class Transaction {
    transaction_key: number;
    transType: string = "";
    wholesaler_fk: number;
    wholesaler: Wholesaler;
    crNum: number;
    amount: number;
    period_fk: number;
    period: Period;
    dateReceived: Date;
    checkDate: Date;
    dateofPayment: Date;
    clearanceCode: string;
    userName: string = "";
    entryDate: Date;
    clearanceDate: Date;
    overRide: boolean;
    approved: boolean;
    retailer: Retailer;
    dueDate: Date;
    selected: boolean;
}
